import React, { FC, ReactNode } from 'react';
import { TextInput } from '@fabric-ui/components';

export type FormComponent = {
  label?: string | React.ReactNode;
  valueName: string;
  required?: boolean;
  isRequired?: boolean;
  params?: any;
  type?: any;
  defaultValue?: any;
  shouldShow?: (data) => boolean;
  text?: ReactNode;
  sendAsArray?: boolean;
  shouldUpdateFieldWith?: (data) => { field: string; value: any };
  onChange?: (value: any) => void;
  changeEffect?: (value: any) => void;
};

export const AvFormComponent: FC<{ formComponents: FormComponent[]; data; onFormChange }> = ({ formComponents, data, onFormChange }) => {
  const onChangeHandler = (field, onChange) => value => {
    onChange?.(value);

    const updatedFields = validateChangeAnotherField(field, value);
    onFormChange(updatedFields);
  };

  const validateChangeAnotherField = (changedField, changedValue) => {
    const toUpdate = { [changedField]: changedValue };
    const component = formComponents.find(({ shouldUpdateFieldWith, valueName }) => valueName === changedField && shouldUpdateFieldWith);
    if (component && component.shouldUpdateFieldWith) {
      const { field, value } = component.shouldUpdateFieldWith(data);
      toUpdate[field] = value;
    }
    return toUpdate;
  };
  return formComponents
    .filter(({ shouldShow = () => true }) => shouldShow(data))
    .map(({ label, valueName, params, required, isRequired, type: Component = TextInput, text, onChange, changeEffect }) =>
      // text is INPUT_TYPES.TEXT
      Component === 'text' ? (
        text
      ) : (
        <Component
          size="small"
          key={valueName}
          label={label}
          value={data[valueName] || (params?.isMultiple ? [] : data[valueName])}
          onChange={(value: any) => {
            if (changeEffect) {
              changeEffect(value);
            }
            return onChangeHandler(valueName, onChange)(value);
          }}
          {...(required !== undefined ? { required } : {})}
          {...(isRequired !== undefined ? { isRequired } : {})}
          {...params}
        />
      )
    );
};
